<template>
  <div class="d-flex justify-between column color-on-cont-dim gap-24 container bg-cont-dim w-100">
    <div class="link-data d-flex gap-16">
      <img class="product-image" v-if="zarinlink?.images?.[0]?.url" :src="zarinlink.images[0].url" alt="" />
      <Icons class="product-image" v-else :name="zarinlink?.type" />

      <div class="d-flex column gap-16 w-100">
        <span class="text-b16 leaning-24 text-ellipsis color-on-cont-bright text-medium">{{ zarinlink.merchant.title }}</span>
        <span class="text-c12 color-black text-medium">{{ renderTypeText }}</span>
      </div>
    </div>
    <MerchantData v-if="zarinlink?.merchant" :merchant="zarinlink?.merchant" :is-personal="false" />
  </div>
</template>
<script setup lang="ts">
import type { ZarinLink } from '@/types';
import Icons from '@/components/base/icon/index.vue';
import MerchantData from './merchant-data.vue';
import { computed, toRefs } from 'vue';

const props = defineProps<{
  zarinlink: ZarinLink;
}>();
const { zarinlink } = toRefs(props);
const renderTypeText = computed(() => {
  if (zarinlink?.value?.type === 'PRODUCT') return 'لینک فروش محصول';
  if (zarinlink?.value?.type === 'PAYMENT') return 'لینک دریافت وجه';
  if (zarinlink?.value?.type === 'RESERVATION') return 'لینک رویداد';
  if (zarinlink?.value?.type === 'SUBSCRIPTION') return 'لینک حمایت مالی';
  return 'لینک فروش محصول';
});
</script>
<style scoped lang="scss">
@import url('./zarinlink-data.scss');
</style>
